<template>
  <a-affix :offset-top="top">
    <div class="nav-box flex-between">
      <img class="logo" src="../assets/images/logo.png" alt="">
      <div class="phone-nav">
        <span @click="handleOrder" class="btn">立即下单</span>
        <img class="menu" @click="handleMenu" src="../assets/images/menu.png" alt="">
      </div>
      <div class="nav-btn-box" v-if="isShowMenu">
        <p @click="handleDom('service')">特色服务</p>
        <p @click="handleDom('FAQ')">托运FAQ</p>
        <p @click="handleDom('partner')">合作伙伴</p>
        <p @click="handleDom('about')">关于我们</p>
        <p @click="handleDom('footer')">联系我们</p>
      </div>
      <div class="nav-btn">
        <span @click="handleDom('service')">特色服务</span>
        <span @click="handleDom('FAQ')">托运FAQ</span>
        <span @click="handleDom('partner')">合作伙伴</span>
        <span @click="handleDom('about')">关于我们</span>
        <span @click="handleDom('footer')">联系我们</span>
        <span @click="handleDom(6)" class="btn">立即下单</span>
      </div>
    </div>
  </a-affix>
  <div class="mask_full isPhone" v-if="isQRcode && isMobile" @click.self="handleCloseFaq">
    <div class="order">
      <img v-if="isMobile" class="close" @click="handleCloseFaq" src="../assets/images/Off.png" alt="">
      <div class="tips">长按保存图片<br/>去微信扫码领取首单优惠</div>
      <img class="gh" src="../assets/images/qrcode_for_gh.jpg" alt="">
    </div>
  </div>
  <div class="screen1 page">
    <div class="screen1-phone">
      <div class="title-h1">先报价后托运丨就上{{siteInfo.name}}</div>
      <p>全国上门取件！可带电池！可打木架！可不带包装托运，整车不拆电瓶一口价，中途绝不加价！</p>
      <div class="isPc" @click="handleDom(6)">立即下单</div>
      <div class="isPhone" @click="handleOrder">立即下单</div>
      <img class="screen1-img" src="../assets/images/bg2.png" alt="">
    </div>
  </div>
  <div class="screen2 page">
    <img class="left-img" src="../assets/images/bg2.png" alt="">
    <div class="right">
      <img class="right-img" src="../assets/images/bg2_2.png" alt="">
      <h2>先报价 后托运 上{{siteInfo.name}}</h2>
      <div class="text">不玩套路 杜绝中途加价行为</div>
      <a-divider/>
      <p>
        上{{siteInfo.name}}——先报价后托运，透明价格，杜绝中途加价！<br/>我们承诺无套路，始终如一的服务质量，让您的运输过程更安心、无忧。<br/>无论是长途还是短途运输，选择上{{siteInfo.name}}，就是选择放心。
      </p>
      <div class="qrcode_box">
        <div class="screen2-qrcode">
          <img src="../assets/images/miniapp-qrcode.png" alt="">
          <div>微信扫码体验小程序</div>
        </div>
        <div class="screen2-qrcode">
          <img src="../assets/images/mp-qrcode.png" alt="">
          <div>微信扫码关注公众号</div>
        </div>
      </div>
    </div>
  </div>
  <div class="screen3 page">
    <img class="phone1" v-if="isMobile" @click="handleOrder" src="../assets/images/phone1.png" alt="">
    <img class="phone1" v-if="!isMobile" @click="handleOpen" src="../assets/images/phone1.png" alt="">
    <div class="left">
      <img class="register" src="../assets/images/register.png" alt="">
      <p>注册即得，50元新人优惠券免费领取！<br/>只要在我们平台注册，即可享受无门槛使用的优惠，电动车、摩托车托运都适用。<br/>让您的运输更实惠、更便捷，赶快加入我们，开启无忧托运之旅！
      </p>
    </div>

    <div class="mask_full isPc" v-if="isMask" @click.self="handleOpen">
      <div class="qrcode">
        <div>
          <img class="code" src="../assets/images/Group130.png" alt="">
          <img class="code1" src="../assets/images/service-qrcode.png" alt="">
        </div>
        <img class="close" @click="handleOpen" src="../assets/images/close.png" alt="">
      </div>
    </div>
  </div>

  <div class="screen4 page">
    <div class="page1">
      <img class="bg4_pc" src="../assets/images/phone2.png" alt="">
      <img class="bg4_phone" src="../assets/images/bg4_2.png" alt="">
      <div class="right">
        <div class="title-box title-box-pc">
          <h2 class="text-h2">定金下单</h2>
          <img src="../assets/images/Group1.png" alt="">
        </div>
        <p>为了让您更安心托运，我们推出了定金下单服务。支付定金后，我们会立即安排司机上门取车。车辆发物流后，我们会将物流面单发送给您，您可以在收到面单后支付尾款。整个过程透明、安全，确保您的爱车顺利托运到目的地！
        </p>
        <img class="Group3" src="../assets/images/Group3.png" alt="">
      </div>
    </div>
    <img class="phone_phone3" src="../assets/images/phone3.png" alt="">

    <div class="page1 page2">
      <div class="right left">
        <div class="title-box">
          <h2 class="text-h2">过往好评</h2>
          <img src="../assets/images/Group1.png" alt="">
          <img src="../assets/images/Group4.png" alt="">
        </div>
        <p>过往好评如潮，用户对我们的服务赞不绝口！无论是托运速度、服务态度，还是价格透明度，客户们都给予了高度评价。‘快速、安全、价格实惠’，这是大家对我们的一致认可。选择上{{siteInfo.name}}，您就是选择了放心与满意！
        </p>
        <img class="Group3" src="../assets/images/Group3.png" alt="">
        <div class="flex screenshot">
          <img src="../assets/images/screenshot1.png" alt="">
          <img src="../assets/images/screenshot2.png" alt="">
        </div>
      </div>
      <img class="pc_phone3" src="../assets/images/phone3.png" alt="">
    </div>
  </div>
  <div class="screen5 page" id="service">
    <div class="title-text title-h1"><img src="../assets/images/title-line.png" alt=""><span>特色服务</span><img
      src="../assets/images/title-line.png" alt=""></div>
    <div class="faq-box">
      <div class="flex-col-center" v-for="(item, index) in serviceList" :key="index">
        <img :src="item.img" alt="">
        <div class="text-h2">{{ item.title }}</div>
        <p class="text-center">{{ item.text }}</p>
      </div>
    </div>
  </div>
  <div class="screen6 page" id="FAQ">
    <div class="title-text title-h1"><img src="../assets/images/title-line.png" alt=""><span>托运FAQ</span><img
      src="../assets/images/title-line.png" alt=""></div>
    <div class="faq-box">
      <div class="faq flex-between faq-item" v-for="(item, index) in FAQList" :key="index" @click="handleOpenFAQ(item)">
        <!-- <img src="../assets/images/q1.png" alt=""> -->
        <!-- <img v-else src="../assets/images/q2.png" alt=""> -->
        <span class="text-span" style="color: #4894F9;font-size: 16px;">{{ item.title }}</span>
        <img src="../assets/images/Frame@2x.png" alt="">
      </div>
    </div>
    <div class="mask_full" v-if="isShowFaq" @click.self="handleCloseFaq">
      <div class="content">
        <img class="close" @click.self="handleCloseFaq" src="../assets/images/Off.png" alt="">
        <div class="flex">
          <img class="q2" src="../assets/images/q2.png" alt="">
          <div class="mask-title">{{ faqInfo.title }}</div>
        </div>
        <div class="scoll">
          <div v-html="faqInfo.content"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="screen7 page" id="about">
    <div>
      <div class="about title-h1">关于我们</div>
      <p v-html="siteInfo.about"></p>
    </div>
    <img src="../assets/images/bg7.png" alt="">
  </div>
  <div class="screen8 page" id="partner">
    <div class="title-text title-h1"><img src="../assets/images/title-line.png" alt=""><span>合作伙伴</span><img
      src="../assets/images/title-line.png" alt=""></div>
    <div class="flex partner">
      <div class="flex-col-center partner-item" v-for="item in partnerList">
        <img :src="item.img" alt="">
        <div class="text-p">{{ item.title }}</div>
      </div>
    </div>
  </div>
  <Footer id="footer" :footerConfig="footerConfig"/>

</template>

<script setup>
import {ref} from 'vue'
import Footer from '@/components/footer.vue';
import partnerImg1 from '@/assets/images/partner-driver.jpg'
import partnerImg2 from '@/assets/images/partner-logistics.jpg'
import partnerImg3 from '@/assets/images/partner-wooden.jpg'
import partnerImg4 from '@/assets/images/partner-car-club.jpg'
import serviceImg1 from '@/assets/images/bg5_1.png'
import serviceImg2 from '@/assets/images/bg5_2.png'
import serviceImg3 from '@/assets/images/bg5_3.png'

const partner1 = partnerImg1
const partner2 = partnerImg2
const partner3 = partnerImg3
const partner4 = partnerImg4
const service1 = serviceImg1
const service2 = serviceImg2
const service3 = serviceImg3

const partnerList = [
  {img: partner1, title: '各地车友'},
  {img: partner2, title: '专线物流公司'},
  {img: partner3, title: '专业木箱木架'},
  {img: partner4, title: '拖车司机'},
]

const siteInfo = {
  name: '托运侠',
  about: '人人寄(深圳)科技有限公司是一家互联网+物流的托运公司，总部位于深圳，服务遍及全国。<br/>\n' +
    '        人人寄致力于整合全行业运力资源，为全国人民提供实惠可靠的物流托运服务。<br/>\n' +
    '        基于行业现状，公司运用互联网思维布局物流行业针对性地设计业务流程，制定服务标准，整合行业信息，<br/>\n' +
    '        快速匹配有需求的托运人与承运商，方便快捷，互利互惠。<br/>\n' +
    '        总之，我们是在物流领域深耕的团队，物流托运选我们准没错。<br/>\n' +
    '        咨询热线:400-688-9593<br/>\n' +
    '        让物流更简单、更实惠、更放心!'
}

const FAQList = [
  {
    title: '电动车托运怎么下单？',
    content: `<h1><a id="%E7%94%B5%E5%8A%A8%E8%BD%A6%E6%89%98%E8%BF%90%E6%80%8E%E4%B9%88%E4%B8%8B%E5%8D%95%EF%BC%9F" class="anchor" aria-hidden="true"><span class="octicon octicon-link"></span></a>电动车托运怎么下单？</h1>
<p>托运侠可以提供自助下单，填写起始和目的地后，自动 计算价格，对价格能接受后，再填写寄件人信息、收件人 信息，即可自助下单。</p>`
  }, {
    title: '电瓶车托运中电瓶能一起寄送吗？',
    content: `<h1><a id="%E7%94%B5%E7%93%B6%E8%BD%A6%E6%89%98%E8%BF%90%E4%B8%AD%E7%94%B5%E7%93%B6%E8%83%BD%E4%B8%80%E8%B5%B7%E5%AF%84%E9%80%81%E5%90%97%EF%BC%9F" class="anchor" aria-hidden="true"><span class="octicon octicon-link"></span></a>电瓶车托运中电瓶能一起寄送吗？</h1>
<p>电瓶车在托运途中是无需拆卸可以一起运走。</p>`
  },
  {
    title: '电动车托运需要打木架吗？',
    content: `<h1><a id="%E7%94%B5%E5%8A%A8%E8%BD%A6%E6%89%98%E8%BF%90%E9%9C%80%E8%A6%81%E6%89%93%E6%9C%A8%E6%9E%B6%E5%90%97%EF%BC%9F" class="anchor" aria-hidden="true"><span class="octicon octicon-link"></span></a>电动车托运需要打木架吗？</h1>
<p>如果路程较近可以不打，如果路程较远，建议打个木架， 因为电动车都是不规则的，而且都是和普货一起运输的， 不打木架在运输中极易造成损坏</p>`
  },
  {
    title: '摩托车托运需要将油箱放空吗？',
    content: `<h1><a id="%E6%91%A9%E6%89%98%E8%BD%A6%E6%89%98%E8%BF%90%E9%9C%80%E8%A6%81%E5%B0%86%E6%B2%B9%E7%AE%B1%E6%94%BE%E7%A9%BA%E5%90%97%EF%BC%9F" class="anchor" aria-hidden="true"><span class="octicon octicon-link"></span></a>摩托车托运需要将油箱放空吗？</h1>
<p>必须放空，为了安全起见， 需要放掉油箱内的油防止发生 事故，若您不懂放油没事，我们运输前可以帮忙放油。</p>`
  }, {
    title: '如何避免物品托运时损坏？',
    content: `<h1><a id="%E5%A6%82%E4%BD%95%E9%81%BF%E5%85%8D%E7%89%A9%E5%93%81%E6%89%98%E8%BF%90%E6%97%B6%E6%8D%9F%E5%9D%8F%EF%BC%9F" class="anchor" aria-hidden="true"><span class="octicon octicon-link"></span></a>如何避免物品托运时损坏？</h1>
<p>对于托运物品托运时怕被托运物流损坏，其实完全不用担心，搬运过程中，除了不可抗力因素，其他原因造成的损坏 都是可以避免的，我们物品在托运的时候车厢始终密封状态，避免阳光直射/避免被雨淋湿其次贴上标签：易碎品在包装表面贴上易碎品标签，这样标签实际上就是在提醒师傅轻拿轻放，搬运过程中格外小心谨慎。</p>`
  }, {
    title: '不打木架能运么？',
    content: `<h1><a id="%E4%B8%8D%E6%89%93%E6%9C%A8%E6%9E%B6%E8%83%BD%E8%BF%90%E4%B9%88%EF%BC%9F" class="anchor" aria-hidden="true"><span class="octicon octicon-link"></span></a>不打木架能运么？</h1>
<p>关于是否打木架，我们提供灵活的选择。您可以选择不打木架运输，我们建议用不用的棉被或衣服包裹重要部分，确保安全。为了进一步保护您的物品，我们还会免费为您缠绕保鲜膜，确保运输过程中无忧。安全、高效、经济，我们为您提供个性化的托运服务！</p>`
  },
  {
    title: '中途会不会加价？',
    content: `<h1><a id="%E4%B8%AD%E9%80%94%E4%BC%9A%E4%B8%8D%E4%BC%9A%E5%8A%A0%E4%BB%B7%EF%BC%9F" class="anchor" aria-hidden="true"><span class="octicon octicon-link"></span></a>中途会不会加价？</h1>
<p>上托运侠——先报价后托运，透明价格，杜绝中途加价！我们承诺无套路，始终如一的服务质量，让您的运输过程更安心、无忧。无论是长途还是短途运输，选择上托运侠，就是选择放心。</p>`
  },
  {
    title: '怎么知道托运要多少钱？',
    content: `<h1><a id="%E6%80%8E%E4%B9%88%E7%9F%A5%E9%81%93%E6%89%98%E8%BF%90%E8%A6%81%E5%A4%9A%E5%B0%91%E9%92%B1%EF%BC%9F" class="anchor" aria-hidden="true"><span class="octicon octicon-link"></span></a>怎么知道托运要多少钱？</h1>
<p>想知道托运费用？非常简单！只需点击‘立即下单’，扫码进入我们的服务小程序，选择您的车型，输入收寄件地址，系统将自动为您查询精确价格。如果有任何疑问或需要帮助，随时联系客服，我们将为您提供一对一的专业支持。</p>`
  },
  {
    title: '是上门取车和送货上门吗？',
    content: `<h1><a id="%E6%98%AF%E4%B8%8A%E9%97%A8%E5%8F%96%E8%BD%A6%E5%92%8C%E9%80%81%E8%B4%A7%E4%B8%8A%E9%97%A8%E5%90%97%EF%BC%9F" class="anchor" aria-hidden="true"><span class="octicon octicon-link"></span></a>是上门取车和送货上门吗？</h1>
<p>我们提供免费上门取车服务！下单后，我们会第一时间安排司机上门取车，确保您的托运流程顺畅无忧。到达目的地后，您可以选择在物流点自提，或者支付相关费用选择送货上门。我们承诺为您提供便捷、安全的全程服务！</p>`
  },
  {
    title: '托运可以携带行李么？',
    content: `<h1><a id="%E6%89%98%E8%BF%90%E5%8F%AF%E4%BB%A5%E6%90%BA%E5%B8%A6%E8%A1%8C%E6%9D%8E%E4%B9%88%EF%BC%9F" class="anchor" aria-hidden="true"><span class="octicon octicon-link"></span></a>托运可以携带行李么？</h1>
<p>关于行李携带，电动车托运时，我们可以免费携带一个行李，只要能放置在电动车的踏板或座椅上即可。如果您的行李较多，我们也提供托盘服务，您可以选择打一个托盘，将所有行李放在托盘上一起托运。需要此服务时，欢迎联系客服，我们会为您提供个性化解决方案！</p>`
  },
]

const isShowMenu = ref(false)
const serviceList = [
  {img: service1, text: '托运前一键估价、快捷下单、师傅当天上门取车', title: '高效便捷'},
  {img: service2, text: '托运侠已安全运输3000+台车辆，无运损丢件，专业包装，全程跟踪', title: '安全省心'},
  {img: service3, text: '覆盖全国300+网点，全国可发', title: '覆盖广泛'},
]

const footerConfig = {
  email: 'bd@tyx365.com',
  companyName: '人人寄（深圳）科技有限公司',
  year: '2025',
  icp: '粤ICP备2024239598号-8',
  quickServices: [
    '电动车托运',
    '摩托车托运',
    '三轮车托运',
    '运单查询',
  ],
  links: [
    {title: '人人寄-便宜寄快递', url: 'https://cpskd.cn/index'},
  ],
}

// 手机跳转页面
const shotlink ="https://link.wiki/ynfHeL"


const faqInfo = ref({})
const faqTitle = ref('')
const isShowFaq = ref(false)
const isQRcode = ref(false)
const isMobile = /Android|iPhone|iPod|BlackBerry/i.test(window.navigator.userAgent)
const isWeixin = /MicroMessenger/i.test(window.navigator.userAgent)
const isMask = ref(false)
const handleOpen = () => {
  isMask.value = !isMask.value
}
const handleMenu = () => {
  isShowMenu.value = !isShowMenu.value
}
const handleDom = (text) => {
  if (text != 6) {
    const serviceElement = document.querySelector("#" + text)
    mgT(serviceElement)
    document.querySelector("#" + text).scrollIntoView(true);
  } else {
    isMask.value = !isMask.value
  }
  isShowMenu.value = false
}
const mgT = (val) => {
  const serviceElement = val
  serviceElement.style.paddingTop = "80px";
}
const handleOpenFAQ = (val) => {
  isShowFaq.value = true
  faqInfo.value = val
}
const handleCloseFaq = () => {
  isShowFaq.value = false
  isQRcode.value = false
}
const handleOrder = () => {
  // 手机下，微信环境，出弹框，非微信，跳短链
  console.log(isWeixin)
  if (isWeixin) {
    isMobile ? isQRcode.value = true : isMask.value = true
  } else {
    window.location.href = shotlink
  }
}
</script>

<style scoped lang="scss">
@import url('../assets/style/pc.scss');
@import url('../assets/style/phone.scss');

.nav-box {
  padding: 20px;
  background-color: #fff;
  box-sizing: border-box;
}

.btn {
  color: #fff;
  background: linear-gradient(to right, #78CAF8, #3179FE);
  border-radius: 40px;
  display: inline;
}

.screen1 {
  background-size: 100% auto;
  background-repeat: no-repeat;

  .title-h1 {
    color: #357DFD;
  }
}

.faq-item {
  background-color: #f5f5f5; /* 浅灰色背景 */
}


.partner-item img {
  width: 100%;
  height: 200px;  /* 增加高度 */
  object-fit: cover;
  object-position: center;
}

.partner-item .text-p {
  font-size: 14px;
  color: #333;
  text-align: center;
}
</style>
